module.exports = __webpack_public_path__ + "img/sec-7_icon-stres.4748a267.svg";